export const stepsData = [
  {
    slug: "inmobi-real-state",
    stepTtl: "portfolio.p1.steps.stepTtl",
    steps: [
      { id: 1, number: "Step 1", title: "portfolio.p1.steps.step1a", text: "portfolio.p1.steps.step1b" },
      { id: 2, number: "Step 2", title: "portfolio.p1.steps.step2a", text: "portfolio.p1.steps.step2b" },
      { id: 3, number: "Step 3", title: "portfolio.p1.steps.step3a", text: "portfolio.p1.steps.step3b" }
    ]
  },
  {
    slug: "procesos-migratorios-apm",
    stepTtl: "portfolio.p2.steps.stepTtl",
    steps: [
      { id: 1, number: "Step 1", title: "portfolio.p2.steps.step1a", text: "portfolio.p2.steps.step1b" },
      { id: 2, number: "Step 2", title: "portfolio.p2.steps.step2a", text: "portfolio.p2.steps.step2b" },
      { id: 3, number: "Step 3", title: "portfolio.p2.steps.step3a", text: "portfolio.p2.steps.step3b" }
    ]
  },
  {
    slug: "settleu",
    stepTtl: "portfolio.p3.steps.stepTtl",
    steps: [
      { id: 1, number: "Step 1", title: "portfolio.p3.steps.step1a", text: "portfolio.p3.steps.step1b" },
      { id: 2, number: "Step 2", title: "portfolio.p3.steps.step2a", text: "portfolio.p3.steps.step2b" },
      { id: 3, number: "Step 3", title: "portfolio.p3.steps.step3a", text: "portfolio.p3.steps.step3b" }
    ]
  },
  {
    slug: "dr-julia-scheinecker",
    stepTtl: "portfolio.p4.steps.stepTtl",
    steps: [
      { id: 1, number: "Step 1", title: "portfolio.p4.steps.step1a", text: "portfolio.p4.steps.step1b" },
      { id: 2, number: "Step 2", title: "portfolio.p4.steps.step2a", text: "portfolio.p4.steps.step2b" },
      { id: 3, number: "Step 3", title: "portfolio.p4.steps.step3a", text: "portfolio.p4.steps.step3b" }
    ]
  },
  {
    slug: "sigma-clinica-dental",
    stepTtl: "portfolio.p5.steps.stepTtl",
    steps: [
      { id: 1, number: "Step 1", title: "portfolio.p5.steps.step1a", text: "portfolio.p5.steps.step1b" },
      { id: 2, number: "Step 2", title: "portfolio.p5.steps.step2a", text: "portfolio.p5.steps.step2b" },
      { id: 3, number: "Step 3", title: "portfolio.p5.steps.step3a", text: "portfolio.p5.steps.step3b" }
    ]
  },
  {
    slug: "kaufast",
    stepTtl: "portfolio.p6.steps.stepTtl",
    steps: [
      { id: 1, number: "Step 1", title: "portfolio.p6.steps.step1a", text: "portfolio.p6.steps.step1b" },
      { id: 2, number: "Step 2", title: "portfolio.p6.steps.step2a", text: "portfolio.p6.steps.step2b" },
      { id: 3, number: "Step 3", title: "portfolio.p6.steps.step3a", text: "portfolio.p6.steps.step3b" }
    ]
  }
];
